<div class="mb-4">
  <h3 class="text-black">Création d'un organisme X.NOT</h3>
</div>

<div class="d-flex flex-column w-50 p-5 border border-1">
  <!-- Form Header -->
  <div class="mb-4">
    <p>
      <small>
        Tous les champs marqués d'un ( * ) sont obligatoires. Pour plus
        d'informations sur le format attendu pour chaque champ, survolez l'icône
        d'information ( i ).</small
      >
    </p>
  </div>

  <!-- User informations form -->
  <div>
    <h6 class="text-black">Information de l'utilisateur</h6>

    <div class="w-full">
      <div class="row my-3">
        <mat-form-field class="col-6" appearance="outline">
          <mat-label>Prénom</mat-label>
          <input
            [formControl]="this.form.controls.firstName"
            matInput
            placeholder="Ex : Marc"
          />
          <mat-icon
            title="Saisissez un prénom de maximum 50 caractères"
            matSuffix
            fontIcon="info"
          >
          </mat-icon>
          <mat-error>Le prénom ne doit pas dépasser 50 caractères</mat-error>
        </mat-form-field>

        <mat-form-field class="col-6" appearance="outline">
          <mat-label>Nom</mat-label>
          <input
            [formControl]="this.form.controls.lastName"
            matInput
            placeholder="Ex : Dupond"
          />
          <mat-icon
            title="Saisissez un nom de maximum 100 caractères"
            matSuffix
            fontIcon="info"
          ></mat-icon>
          <mat-error>Le nom ne doit pas dépasser 100 caractères</mat-error>
        </mat-form-field>
      </div>

      <div class="row my-3">
        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input
            [formControl]="this.form.controls.email"
            matInput
            placeholder="Ex : marc.dupond@notaire.fr"
          />
          <mat-icon
            title="• Utilisez uniquement des lettres minuscules et des chiffres.
• Vous pouvez ajouter un point (.), un tiret (-) ou un underscore (_) avant le '@'.
• L'email doit contenir un '@' suivi d'un domaine.
• Le domaine se compose de lettres/chiffres, séparés par des points ou des tirets, et se termine par au moins 2 lettres.
• Ne dépassez pas 255 caractères."
            matSuffix
            fontIcon="info"
          >
          </mat-icon>
          <mat-error *ngIf="this.form.controls.email.hasError('invalidEmail')">
            Adresse e-mail invalide.
          </mat-error>
          <mat-error *ngIf="this.form.controls.email.hasError('required')">
            Adresse e-mail requise.
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row my-3">
        <mat-form-field appearance="outline">
          <mat-label>Identifiant</mat-label>
          <input
            [formControl]="this.form.controls.login"
            matInput
            placeholder="Ex : marc.dupond"
          />
          <mat-icon
            title="• Utilisez uniquement des lettres minuscules et des chiffres.
• Seuls les caractères suivants sont autorisés : point (.), tiret (-), underscore (_).
• Aucun espace n'est autorisé.
• La saisie doit contenir au maximum 100 caractères."
            matSuffix
            fontIcon="info"
          ></mat-icon>
          <mat-error *ngIf="this.form.controls.login.hasError('invalidLogin')">
            Identifiant invalide.
          </mat-error>
          <mat-error *ngIf="this.form.controls.login.hasError('required')">
            Identifiant requis.
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>

  <mat-divider class="my-4"></mat-divider>

  <!-- Organism informations form -->
  <div>
    <h6 class="text-black">Information de l'organisme</h6>

    <div class="w-full">
      <div class="row my-3">
        <mat-form-field class="col-6" appearance="outline">
          <mat-label>Code Client (CRPCEN)</mat-label>
          <input
            [formControl]="this.form.controls.code"
            matInput
            placeholder="Ex : F12345"
          />
          <mat-icon
            title="• Utilisez uniquement des lettres majuscules et des chiffres.
• La saisie doit contenir au maximum 6 caractères."
            matSuffix
            fontIcon="info"
          ></mat-icon>
          <mat-error
            *ngIf="this.form.controls.code.hasError('invalidLogin') || this.form.controls.code.hasError('maxlength')"
          >
            Code client invalide.
          </mat-error>
          <mat-error *ngIf="this.form.controls.code.hasError('required')">
            Code client requis.
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row my-3">
        <mat-form-field appearance="outline">
          <mat-label>Nom de l'organisme</mat-label>
          <input
            [formControl]="this.form.controls.compagnyName"
            matInput
            placeholder="Ex : Office notarial Dupond & Associés"
          />
          <mat-icon
            title="La saisie doit contenir au maximum 200 caractères."
            matSuffix
            fontIcon="info"
          ></mat-icon>
          <mat-error
            *ngIf="this.form.controls.compagnyName.hasError('maxlength')"
          >
            Le nom de l'organisme ne doit pas dépasser 200 caractères
          </mat-error>
          <mat-error
            *ngIf="this.form.controls.compagnyName.hasError('required')"
          >
            Nom de l'organisme requis.
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row my-3">
        <mat-form-field appearance="outline">
          <mat-label>Adresse (Ligne 1)</mat-label>
          <input
            [formControl]="this.form.controls.adressLine1"
            matInput
            placeholder="Ex : 24 RUE PARADIS"
          />
          <mat-icon
            title="La saisie doit contenir au maximum 100 caractères."
            matSuffix
            fontIcon="info"
          ></mat-icon>
          <mat-error>
            L'adresse ligne 1 ne doit pas dépasser 100 caractères
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row my-3">
        <mat-form-field appearance="outline">
          <mat-label>Adresse (Ligne 2)</mat-label>
          <input
            [formControl]="this.form.controls.adressLine2"
            matInput
            placeholder="Ex : Résidence Lumière"
          />
          <mat-icon
            title="La saisie doit contenir au maximum 100 caractères."
            matSuffix
            fontIcon="info"
          ></mat-icon>
          <mat-error>
            L'adresse ligne 2 ne doit pas dépasser 100 caractères
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row my-3">
        <mat-form-field appearance="outline">
          <mat-label>Adresse (Ligne 3)</mat-label>
          <input
            [formControl]="this.form.controls.adressLine3"
            matInput
            placeholder="Ex : Bâtiment A"
          />
          <mat-icon
            title="La saisie doit contenir au maximum 100 caractères."
            matSuffix
            fontIcon="info"
          ></mat-icon>
          <mat-error>
            L'adresse ligne 3 ne doit pas dépasser 100 caractères
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field class="col-6" appearance="outline">
          <mat-label>Code postal</mat-label>
          <input
            [formControl]="this.form.controls.zipCode"
            matInput
            placeholder="Ex : 13100"
          />
          <mat-icon
            title="La saisie doit contenir que des chiffres. Maximum 5 caractères."
            matSuffix
            fontIcon="info"
          ></mat-icon>
          <mat-error> Le code postal est invalide </mat-error>
        </mat-form-field>

        <mat-form-field class="col-6" appearance="outline">
          <mat-label>Ville</mat-label>
          <input
            [formControl]="this.form.controls.city"
            matInput
            placeholder="Ex : Aix-en-Provence"
          />
          <mat-icon
            title="La saisie doit contenir au maximum 50 caractères."
            matSuffix
            fontIcon="info"
          ></mat-icon>
          <mat-error> La ville ne doit pas dépasser 50 caractères </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row my-3">
      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input
          [formControl]="this.form.controls.emailOrganisme"
          matInput
          placeholder="Ex : marc.dupond@notaire.fr"
        />
        <mat-icon
          title="• Utilisez uniquement des lettres minuscules et des chiffres.
• Vous pouvez ajouter un point (.), un tiret (-) ou un underscore (_) avant le '@'.
• L'email doit contenir un '@' suivi d'un domaine.
• Le domaine se compose de lettres/chiffres, séparés par des points ou des tirets, et se termine par au moins 2 lettres.
• Ne dépassez pas 255 caractères."
          matSuffix
          fontIcon="info"
        >
        </mat-icon>
        <mat-error
          *ngIf="this.form.controls.emailOrganisme.hasError('invalidEmail')"
        >
          Adresse e-mail invalide.
        </mat-error>
      </mat-form-field>
    </div>

    <div class="row my-3">
      <mat-form-field appearance="outline">
        <mat-label>Téléphone</mat-label>
        <input
          [formControl]="this.form.controls.phone"
          matInput
          placeholder="Ex : 0123456789"
        />
        <mat-icon
          title="Veuillez saisir un numéro valide : 10 chiffres requis, débutant par 0"
          matSuffix
          fontIcon="info"
        >
        </mat-icon>
        <mat-error> Téléphone invalide </mat-error>
      </mat-form-field>
    </div>
  </div>

  <mat-divider class="my-5"></mat-divider>

  <!-- Credit pack form -->
  <div class="d-flex flex-column">
    <h6 class="text-black">Commande de crédits</h6>

    <mat-form-field>
      <mat-label>Pack</mat-label>
      <mat-select
        [formControl]="this.form.controls.offerId"
        (selectionChange)="packSelectionChanged()"
      >
        <mat-option value="aucun">Aucun</mat-option>
        <mat-option *ngFor="let pack of packs" [value]="pack.id">
          {{pack.creditTotal}}
          <span *ngIf="pack.specialLabel.length > 0">
            - {{pack.specialLabel}}
          </span>
        </mat-option>
      </mat-select>
      <mat-error> Le pack est obligatoire </mat-error>
    </mat-form-field>

    <mat-checkbox [formControl]="this.form.controls.isReplenishment">
      Renouvellement automatique
    </mat-checkbox>
  </div>

  <div
    class="d-flex flex-column justify-content-center align-items-center mt-5 w-full"
  >
    <div *ngIf="errorMsg" class="alert alert-danger" role="alert">
      <strong>Erreur ! </strong>
      {{ errorMsg }}
    </div>

    <button
      class="col-4"
      color="primary"
      mat-raised-button
      [disabled]="!form.valid"
      (click)="onSubmit()"
    >
      Valider
    </button>
  </div>
</div>
